import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=1b810174&scoped=true"
import script from "./Field.vue?vue&type=script&lang=ts"
export * from "./Field.vue?vue&type=script&lang=ts"
import style0 from "./Field.vue?vue&type=style&index=0&id=1b810174&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b810174",
  null
  
)

export default component.exports